import loglevel from 'loglevel';
import { newRelicEmitter, UNFULFILLED_PROMISE_EVENT} from 'lib/metrics/newRelicEventBus';
import request from './cache/requestCache';
import proxy from './requestProxy';
import fallback from './cache/fallbackCache';
import { secureCdnHost } from 'config';

const log = loglevel.getLogger('NetworkImageData');

const DEFAULT_EXPIRATION = 600;    // 10 minutes
const DEFAULT_TIMEOUT = 5000;
const NETWORK_IMAGE_DATA_URL = `${secureCdnHost}/connected-devices/images/data.json`;

function getUrl() {
    let url = NETWORK_IMAGE_DATA_URL;
    if (!process.browser) { // use non ssl domain for server side
        url = url.replace(secureCdnHost, 'http://proxy.espn.com');
    }
    return url;
}

export default function get() {
    const url = getUrl();
    return request.get(url)
        .expiration(DEFAULT_EXPIRATION)
        .use(proxy)
        .timeout(DEFAULT_TIMEOUT)
        .then(({ body }) => {
            fallback.set(url, body);
            return body;
        })
        .catch((err) => {
            log.error(`load network image data: ${url}`, err.originalError);
            newRelicEmitter.emit(UNFULFILLED_PROMISE_EVENT, err);
            return fallback.get(url)
                .then(networkImageData => {
                    if (!networkImageData) {
                        return networkImageData;
                    }
                    return {};
                });
        });
}



// WEBPACK FOOTER //
// ./app/lib/api/NetworkImageData.js